//bao migrate skip
import * as ko from "knockout";
ko.bindingHandlers.sorting = {
    removeSortIcon: function (element) {
        if ($(".sorting-direction", element).length > 0) {
            $(".sorting-direction", element).remove();
        }
    },
    setSortIcon: function (element, direction) {
        if (direction == "Ascending") {
            $(element).append("<span class='sorting-direction fal fa-chevron-up'></span>");
        }
        else if (direction == "Descending") {
            $(element).append("<span class='sorting-direction fal fa-chevron-down'></span>");
        }
    },
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        if (valueAccessor() != null && valueAccessor().value != null && ko.isObservable(valueAccessor().value)) {
            var key = ko.toJS(valueAccessor().key);
            $(element).addClass("clickable");
            valueAccessor().value.subscribe(function () {
                ko.bindingHandlers.sorting.removeSortIcon(element);
                ko.utils.arrayForEach(valueAccessor().value(), function (s: any) {
                    if (s.Column == key) {
                        ko.bindingHandlers.sorting.setSortIcon(element, s.Direction);
                    }
                });
            });
            if (valueAccessor().defaultSort != undefined) {
                var defaultSort = ko.unwrap(valueAccessor().defaultSort);
                if (defaultSort == "Ascending" || defaultSort == "Descending") {
                    ko.bindingHandlers.sorting.setSortIcon(element, defaultSort);
                    var sortingArray = ko.unwrap(valueAccessor().value);
                    sortingArray.push({
                        Column: ko.unwrap(valueAccessor().key),
                        Direction: defaultSort
                    });
                }
            }
            $(element).click(function (e) {
                var foundSorting = null;
                var currentSorting = valueAccessor().value();
                if (currentSorting != null) {
                    $.each(currentSorting, function (index, s) {
                        if (s.Column == key) {
                            foundSorting = s;
                        }
                    });
                }
                if (e.ctrlKey && currentSorting != null && currentSorting.length > 0) {
                    if (foundSorting == null) {
                        foundSorting = {
                            Column: key,
                            Direction: "Ascending"
                        };
                        valueAccessor().value.push(foundSorting);
                    }
                    else {
                        if (foundSorting.Direction == "Ascending") {
                            foundSorting.Direction = "Descending";
                        }
                        else {
                            foundSorting.Direction = "Ascending";
                        }
                        valueAccessor().value.valueHasMutated();
                    }
                }
                else {
                    if (foundSorting == null) {
                        foundSorting = {
                            Column: key,
                            Direction: "Ascending"
                        };
                    }
                    else {
                        if (foundSorting.Direction == "Ascending") {
                            foundSorting.Direction = "Descending";
                        }
                        else {
                            foundSorting.Direction = "Ascending";
                        }
                    }
                    valueAccessor().value([foundSorting]);
                }
            });
        }
    }
};